import { inject, Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DefaultSystemBrowserOptions, InAppBrowser } from '@capacitor/inappbrowser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class BrowserService {
  translateService = inject(TranslateService);

  isWeb = Capacitor.getPlatform() == 'web';

  openTerms() {
    if (this.translateService.currentLang === 'ge') {
      this.openUrl('https://startprint.net/ka/terms');
    } else {
      this.openUrl('https://startprint.net/terms');
    }
  }

  openPrivacy() {
    if (this.translateService.currentLang === 'ge') {
      this.openUrl('https://startprint.net/ka/privacy');
    } else {
      this.openUrl('https://startprint.net/privacy');
    }
  }

  async openUrl(url: string | undefined) {
    if (!url) return;

    if (this.isWeb) {
      window.open(url, '_blank');
      return;
    }

    await InAppBrowser.openInSystemBrowser({
      url: url,
      options: DefaultSystemBrowserOptions,
    });
  }
}
